import script from "./EventLogView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventLogView.vue?vue&type=script&setup=true&lang=ts"

import "./EventLogView.vue?vue&type=style&index=0&id=d7d13756&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7d13756"]])

export default __exports__